import axiosIns from "@/api/axios";

export const GET_LIST = (params) => {
  return axiosIns.get(`/users?${params}`);
};
